import { ShopTagInfo } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'

export interface ShopTagInfoInput {
  id?: GQL_ID
  icon_id?: GQL_ID
  name?: string
  system_name: string
  sort_order?: number
  i18n?: {
    language_code: string
    name: string
  }[]
}

export interface UpdateShopTagInfoInput {
  newData: ShopTagInfoInput
  upsert?: boolean
}

export interface UpdateShopTagInfo {
  shopTagInfo: ShopTagInfo
}

export const GQL_MUTATION_UPDATE_SHOP_TAG_INFO = gql`
  mutation UpdateShopTagInfo(
    $newData: ShopTagInput!
    $upsert: Boolean
  ) {
    shopTagInfo: updateShopTag(newData: $newData, upsert: $upsert) {
      id
      name
      system_name
      sort_order
      icon_id
      icon {
        url
      }
      i18n {
        language_code
        name
      }
    }
  }
`

export const useMutateUpdateShopTagInfo = () => useMutation<UpdateShopTagInfo, UpdateShopTagInfoInput>(GQL_MUTATION_UPDATE_SHOP_TAG_INFO)